module.exports = __webpack_public_path__ + "static/media/logo.368355d9.svg";